import MessagesListPageContainer from './containers/MessagesListPageContainer'

export default MessagesListPageContainer
